<ion-item lines="none">
  <ion-select interface="action-sheet" placeholder="Domicilio registrado No." (ionChange)="changeActiveAddress($event)"
    value="{{ activeAddressUid }}">
    <ion-select-option *ngFor="let address of addresses" value="{{ address.uid }}">
     <!-- {{ (isGuest)? 'C.P. ' + address.address4 : address.address1 }}-->
      {{ (isGuest)? 'Invitado' : address.address1 }}
    </ion-select-option>
  </ion-select>
</ion-item>